
export interface ReptileControls {
    browseMorphs: boolean,
    caresheet: boolean,
    collection: boolean,
    geneticCalculator: boolean,
    isSpecies: boolean,
    isActive: boolean
}

export interface Reptile {
    accronym: string,
    controls: ReptileControls | null,
    reptile_name: string
}
export const blankReptile: Reptile = {
    accronym: "",
    controls: null,
    reptile_name: ""
}